import { Button } from '@/components/ui/button';
// import { deleteGolfProfile } from '@/utils/actions'; // Import the delete function
import { useTranslation } from 'react-i18next';
import { useAppNavigation } from '@/lib/i18nNavigation';
import { useState } from 'react';
import { IonActionSheet, IonButton } from '@ionic/react';
import { trash, close } from 'ionicons/icons';
import { t } from 'i18next';

const DeleteProfile = () => {
  const [actionSheetOpen, setActionSheetOpen] = useState(false);
  const { navigate } = useAppNavigation();
  const { t } = useTranslation();
  const handleDeleteProfile = async () => {
    try {
      // await deleteGolfProfile(userProfile.id); // Call the delete function with the profile ID
      navigate('/'); // Redirect to the root path
    } catch (error) {
      console.error('Error deleting profile:', error);
    }
  };

  return (
    <>
      <IonButton fill="outline" color="danger" onClick={() => setActionSheetOpen(true)}>
        {t('delete_account')}
      </IonButton >

      {/* Action Sheet for confirmation */}
      < IonActionSheet
        isOpen={actionSheetOpen}
        onDidDismiss={() => setActionSheetOpen(false)}
        header={t('delete_account')}
        subHeader={t('delete_account_warning_caption')}
        cssClass="action-sheet-danger"
        buttons={
          [
            {
              text: t('delete'),
              role: 'destructive',
              icon: trash,
              handler: handleDeleteProfile
            },
            {
              text: t('cancel'),
              role: 'cancel',
              icon: close
            }
          ]}
      />
    </>
  );
};

export default DeleteProfile;
